import { buildBookRoute } from "./book";
import { buildBooksRoute } from "./books";
import { buildHomeRoute } from "./home";

export { PageLayout } from "./layout";

export const routes = [buildHomeRoute, buildBooksRoute, buildBookRoute];
